/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */
'use strict';

module.exports = {
  monospace: {
    family: 'Menlo, Consolas, monospace',
    sizes: {
      normal: 11,
      large: 14,
    },
  },
  sansSerif: {
    family: '"Helvetica Neue", "Lucida Grande", -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, sans-serif',
    sizes: {
      small: 10,
      normal: 12,
      large: 14,
    },
  },
};



/** WEBPACK FOOTER **
 ** /Users/bvaughn/Documents/git/react-devtools/frontend/Themes/Fonts.js
 **/